import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "09E55A39-B0F4-4168-805A-B43CEB8B51E7";

class GenerateCountAdjustmentsPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }

    loadState() {
        // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }

    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <Scrolling mode="virtual" useNative={false} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={100} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column dataField="countReferenceNumber" caption="Reference #"  />
                    <Column dataField="warehouse" caption="Warehouse"  />
                    <Column dataField="countDetailStatus" caption="Count Status"  />
                    <Column dataField="locationCode" caption="Location"  />
                    <Column dataField="itemCode" caption="Item"  />
                    <Column dataField="description1" caption="Item Description 1"  />
                    <Column dataField="lotCode" caption="Lot"  />
                    <Column dataField="varianceReasonCode" caption="Variance Reason"  />
                    <Column dataField="countedBy" caption="Counted By"  />
                    <Column dataField="entererName" caption="Entered By"  />
                    <Column dataField="customer" caption="Customer"  />
                    <Column dataField="description2" caption="Description 2"  visible={false} />
                    <Column dataField="finalInventoryQuantity" caption="Count"  visible={false} />
                    <Column dataField="sublotCode" caption="Sublot Code"  visible={false} />
                    <Column dataField="unitCode" caption="Unit"  visible={false} />
                    <Column dataField="inventoryQuantity" caption="Quantity"  visible={false} />
                    <Column dataField="physicalCountCode" caption="Count Cycle"  visible={false} />
                    <Column dataField="piecesPerUnitQuantity" caption="Pieces/Unit" visible={false}  />
                    <Column dataField="unitsPerPackageQuantity" caption="Units/Pkg"  visible={false} />
                    <Column dataField="packagesPerShippingUnitQuantity" caption="Packages/Ship"  visible={false} />
                    <Column dataField="recordNumber" caption="Record #" visible={false} />


                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(GenerateCountAdjustmentsPreview);